import { Description } from '@/tools/itemProperties/Description';
import type { DescriptionProps } from '@/tools/itemProperties/Description';

export type ItemDescriptionProps = DescriptionProps;

export const ItemDescription = (props: ItemDescriptionProps) => (
  <Description
    {...props}
    testId="itemDescription"
    classNames={{
      container: 'dl-striped-reversed dl-horizontal-indented properties-list',
      editableContainer: 'striped',
      editableLabel: 'striped',
      readonlyContainer: 'striped',
      readonlyLabel: 'striped',
    }}
  />
);
